// bao migrate skip
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import SearchPaging from "./../factories/search-paging";
import BaoDialog from "./../factories/bao-dialog";
import TabPage from "./../factories/tab-page";
import TabController from "./../factories/tab-controller";
import "./../bindings/bao-tabs";
import "./../bindings/bao-searcher";
import "./../bindings/bao-date-time-box";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-number-box";
import emailTemplate from "./../factories/Email-validation-dialog.html";
import BaseViewModel from "../factories/base-view-model";

function ReportDispatcherViewModel(tabPage) {
    var self = this;
    self.IsShiftbook = ko.observable(false);
    self.IsSummaryReport = ko.observable(true);
    self.ShiftbookTypeValue = ko.observable();
    self.ReportType = ko.observable("");
    self.Disabled = ko.observable(false);
    self.SelectedReportLanguage = ko.observable();
    self.EnabledReportShipping = ko.pureComputed({
        read: function () {
            return !self.Disabled();
        },

        write: function (value) {
            self.Disabled(!value);
        }

        

    });
    self.GroupReportRadioButtonName = ko.observable("");

    self.loaded = function () {
        self.GroupReportRadioButtonName("groupReport_" + this.ReportDispatcherId());
        if (self.IsNew()) {
            self.StepsBack(1);
        }        
        switch (self.StepsBack())
        {
            case 1:
                self.ReportType("1");
                break;
            case 0:
                self.ReportType("0");
                break;
            default:
                self.ReportType("");
        }
        self.TabPage.DirtyFlag.reset();
        self.Initialized(true);
        self.TabPage.IsLoading(false);
    };
    self.AllowOnlyPositiveNumber = () => {
        if ($.isNumeric(self.StepsBack()) && self.StepsBack() < 0) {
            self.StepsBack("");
        }
    }
    self.EnabledReportShipping.subscribe(value => {
        self.Disabled(!value);
    })
    self.ShiftbookTypeValue.subscribe(function (selectedItem) {
        if (selectedItem !== null && selectedItem === "valueSummary") {
            self.IsShiftbook(false);
            self.IsSummaryReport(true);
            self.ShiftbookId(null);
            self.ShiftbookName(null);
        }
        else {
            self.IsShiftbook(true);
            self.IsSummaryReport(false);
            self.SummaryReportId(null);
            self.SummaryReportName(null);
        }
    });
    self.valueSummary = ko.computed({
        read: function () {
            return this.ShiftbookTypeValue() === "valueSummary";
        },
        write: function (value) {
            if (value)
                this.ShiftbookTypeValue("valueSummary");
        }
    }, this);
    self.valueShiftbook = ko.computed({
        read: function () {
            return this.ShiftbookTypeValue() === "valueShiftbook";
        },
        write: function (value) {
            if (value)
                this.ShiftbookTypeValue("valueShiftbook");
        }
    }, this);
    BaseViewModel.call(this, tabPage);
    self.EndTimeJs = ko.observable("");
    if (typeof String.prototype.endsWith !== "function") {
        String.prototype.endsWith = function (suffix) {
            return this.indexOf(suffix, this.length - suffix.length) !== -1;
        };
    }
    self.SelectedUser = ko.observableArray();
    self.GetListOfInvalidEmailAddress = (str: string): Array<string> => {
        let regexDelimiter = /[;<>]/;
        let valTrimmed = str.split(regexDelimiter);
        let emails = [];
        let regexEMailAddress=/^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i;

        valTrimmed.forEach((item) => {
            if (!Bao.Utils.String.IsNullOrWhitespace(item.trim()) && !regexEMailAddress.test(item.trim())) {
                emails.push(item);
            }
        });
        return emails;
    }
    self.CompleteCheck = function () {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(self.ShiftbookId()) && Bao.Utils.String.IsNullOrEmpty(self.SummaryReportId())
            || Bao.Utils.String.IsNullOrEmpty(self.AdressName())
            || (Bao.Utils.String.IsNullOrEmpty(self.ReportType()) && Bao.Utils.String.IsNullOrEmpty(self.StepsBack()))
            || (Bao.Utils.String.IsNullOrEmpty(self.Frequency()))
            || (Bao.Utils.String.IsNullOrEmpty(self.ExecutionTimeJs()))
            || (Bao.Utils.String.IsNullOrEmpty(self.SelectedReportLanguage()))
            || (self.Frequency() == 2 && (!self.MondayChecked() && !self.TuesdayChecked() && !self.WednesdayChecked()
                && !self.ThursdayChecked() && !self.FridayChecked() && !self.SaturdayChecked() && !self.SundayChecked()))) {
            isComplete = false;
        }

        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        else {
            let arrayOfInvalidEmails = self.GetListOfInvalidEmailAddress(self.AdressName());
            if (arrayOfInvalidEmails?.length > 0) {
                isComplete = false;
                let emailValidationDialog = new BaoDialog(Bao.Session.ApplicationName, emailTemplate);
                emailValidationDialog.Open();
                emailValidationDialog.ViewModel({ InvalidEmails: arrayOfInvalidEmails, Heading: Bao.Session.GetMessage("msgEmailValidationHeading")});
                emailValidationDialog.Width(480);
                emailValidationDialog.Buttons([
                    new BaoDialog.ButtonFactory(emailValidationDialog, Bao.Session.GetMessage("msgOk"), () => {
                        emailValidationDialog.Close();
                    })
                ]);
            }
        }
        return isComplete;
    };
    self.openUserSearcher = function () { };

    self.showEmailTooltip = function () {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgEmailTooltip"), "info");
        dialog.Width(580);
    };
    self.showAdvanceOptionInfoDetail = function () {
        let dialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgReportDispatcherAdvanceOptionHelpText"), "info");
        dialog.Width(525);
    };
    self.baoSearcherEmailItems = ko.observableArray();
    self.ReportType.subscribe(value => {
        if (self.Initialized()) {
            self.StepsBack(value);
        }
    })

    self.SelectedUser.subscribe(function (selectedItems) {
        if (selectedItems != null && selectedItems.length > 0) {
            ko.utils.arrayForEach(selectedItems, function (item: any) {
                if (item.Email && !Bao.Utils.String.IsNullOrEmpty(item.Email.trim())) {
                    if (self.AdressName() && !Bao.Utils.String.IsNullOrEmpty(self.AdressName().trim()) && !self.AdressName().trim().endsWith(";")) {
                        self.AdressName(self.AdressName() + "; ");
                    }
                    self.AdressName(self.AdressName() + item.Email.trim() + "; ");
                }
            });
            self.SelectedUser([]);
            self.baoSearcherEmailItems([]);
        }
    });
}
Bao.inherit(ReportDispatcherViewModel, BaseViewModel);
ReportDispatcherViewModel.prototype.PrimaryKey = "ReportDispatcherId";
ReportDispatcherViewModel.prototype.RefreshUrl = "ReportDispatcher/Get";
ReportDispatcherViewModel.prototype.SaveUrl = "ReportDispatcher/Save";
ReportDispatcherViewModel.prototype.DeleteUrl = "ReportDispatcher/Delete";
ReportDispatcherViewModel.prototype.IsInUseUrl = "ReportDispatcher/IsInUse";
ReportDispatcherViewModel.prototype.PermissionForward = "ReportDispatcherForward";
ReportDispatcherViewModel.prototype.PermissionBackward = "ReportDispatcherBackward";
ReportDispatcherViewModel.prototype.PermissionSave = "ReportDispatcherSave";
ReportDispatcherViewModel.prototype.PermissionRefresh = "ReportDispatcherRefresh";
ReportDispatcherViewModel.prototype.PermissionDelete = "ReportDispatcherDelete";
export default ReportDispatcherViewModel;